/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminImpersonateResponse
 */
export interface AdminImpersonateResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminImpersonateResponse
     */
    redirectUrl: string;
}

/**
 * Check if a given object implements the AdminImpersonateResponse interface.
 */
export function instanceOfAdminImpersonateResponse(value: object): value is AdminImpersonateResponse {
    if (!('redirectUrl' in value) || value['redirectUrl'] === undefined) return false;
    return true;
}

export function AdminImpersonateResponseFromJSON(json: any): AdminImpersonateResponse {
    return AdminImpersonateResponseFromJSONTyped(json, false);
}

export function AdminImpersonateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminImpersonateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'redirectUrl': json['redirectUrl'],
    };
}

export function AdminImpersonateResponseToJSON(json: any): AdminImpersonateResponse {
    return AdminImpersonateResponseToJSONTyped(json, false);
}

export function AdminImpersonateResponseToJSONTyped(value?: AdminImpersonateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'redirectUrl': value['redirectUrl'],
    };
}

